exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Views-module__wrapper___2G47v{display:grid;grid-auto-flow:column;gap:1.5rem;justify-content:start;overflow:auto;align-items:start;padding:1.25rem;scroll-behavior:smooth}@supports (-moz-appearance:none){.Views-module__wrapper___2G47v{scrollbar-width:thin;scrollbar-color:rgba(39,46,53,.5) transparent}}@media screen and (-webkit-min-device-pixel-ratio:0) and (min-resolution:0.001dpcm){.Views-module__wrapper___2G47v::-webkit-scrollbar{width:7px;height:7px}.Views-module__wrapper___2G47v::-webkit-scrollbar-track{background:transparent}.Views-module__wrapper___2G47v::-webkit-scrollbar-thumb{background-color:rgba(39,46,53,.5);border-radius:8px}}", ""]);

// exports
exports.locals = {
	"wrapper": "Views-module__wrapper___2G47v"
};